import { render, staticRenderFns } from "./QuizFreeText.vue?vue&type=template&id=e0738a04&"
import script from "./QuizFreeText.vue?vue&type=script&lang=js&"
export * from "./QuizFreeText.vue?vue&type=script&lang=js&"
import style0 from "./QuizFreeText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports